import { useMutation, useQueryCache } from 'react-query';
import { WebsiteMessageAPI } from 'api/websiteMessage';
import { WEBSITE_MESSAGES } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useRemoveWebsiteMessage() {
  const queryCache = useQueryCache();

  return useMutation(WebsiteMessageAPI.remove, {
    onSuccess: ({ message }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(WEBSITE_MESSAGES);
    },
  });
}
